import React, { useEffect, useState } from 'react';
import { Box, Button, Link, Typography } from '@mui/material';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookieConsent');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        bgcolor: 'background.paper',
        p: 2,
        boxShadow: 3,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1000,
      }}
    >
      <Typography
        sx={{ mb: { xs: 1, sm: 0 }, textAlign: { xs: 'center', sm: 'left' } }}
      >
        Utilizamos cookies para melhorar sua experiência. Ao continuar navegando, você concorda com a nossa{' '}
        <Link href="/politica-privacidade" target="_blank" rel="noopener noreferrer">
          Política de Privacidade
        </Link>{' '}
        e{' '}
        <Link href="/politica-cookies" target="_blank" rel="noopener noreferrer">
          Política de Cookies
        </Link>.
      </Typography>
      <Button variant="contained" color="success" onClick={handleAccept}>
        Aceitar
      </Button>
    </Box>
  );
};

export default CookieConsent;
